import { render, staticRenderFns } from "./PopFreeTrail.vue?vue&type=template&id=3b6cdda6&lang=pug"
import script from "./PopFreeTrail.vue?vue&type=script&lang=js"
export * from "./PopFreeTrail.vue?vue&type=script&lang=js"
import style0 from "./PopFreeTrail.vue?vue&type=style&index=0&id=3b6cdda6&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports